import { render, staticRenderFns } from "./CarouselM.vue?vue&type=template&id=4ce4c74f&scoped=true&"
import script from "./CarouselM.vue?vue&type=script&lang=js&"
export * from "./CarouselM.vue?vue&type=script&lang=js&"
import style0 from "./CarouselM.vue?vue&type=style&index=0&id=4ce4c74f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4c74f",
  null
  
)

export default component.exports